export default "__VITE_ASSET__17ca6eeb__"